import { createSlice } from "@reduxjs/toolkit";
import { updateDoctorEmergencySchedule } from "../../reducer/emergencySchedule/updateEmergencyScheduleReducer";

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const doctorEmergencyScheduleSlice = createSlice({
  name: "doctorEmergencySchedule",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateDoctorEmergencySchedule.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateDoctorEmergencySchedule.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(updateDoctorEmergencySchedule.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default doctorEmergencyScheduleSlice.reducer;
